// extracted by mini-css-extract-plugin
export default {"Content":"SectionTitle_Content__i6sZs","Title":"SectionTitle_Title__uPpnC"};